import React, { useCallback, useEffect, useRef, useState } from 'react';
import { LeadsModel } from './models/LeadsModel'
import { LeadsPageModel, SPLeadModel, LeadModel, LeadFilterModel } from './models/superbit-api-models'
import { IDNameDescriptionDictionary, AutocompleteData } from './models/Site'
import { SimulatorModel } from './models/SimulatorModel';
import { GeneralDataModel } from './models/GeneralDataModel';
import { Lead } from './leads/_Lead'
import LeadPopup from './leads/_LeadPopup'
import { Menu } from './_Menu'
import Header from './Header';
import Footer from './_Footer'
import './assets/css/leads_p0001.css?a=111'
import './assets/css/leads.css'
import './assets/css/_simple-popup.css'
import './assets/css/_new-lead-popup.css'
import { IDNameDescriptionItemSelect } from './components/_IDNameDescriptionItemSelect';
import Pagger from './components/_Pagger';
import PleaseWaitLayer from './components/_PleaseWaitLayer';
import moment from 'moment';
import generalSettings from './json/general-settings.json';
import { Select, TreeSelect } from 'antd';
import { LeadDocumentPopup } from './leads/_LeadDocumentPopup';
import { LeadMessagePopup } from './leads/_LeadMessagePopup';
import { useDispatch, useSelector } from 'react-redux';
import LoginPopup from './login/_LoginPopUp';
import LoginStatus from './login/_LoginStatus';
import { LoginModel } from './models/LoginModel';
import GoToLogin from './login/_goToLogin';
import CompDatePicker from './components/compDatePicker/_CompDatePicker';
import StationUserSelect from './components/_StationUserSelect';
import { setBranchesData, setIdForLeadPopup } from './app-context/policyProduction';
import { RootState } from './app-context/store';
import LeadOfferProduction from './leads/_LeadOfferProduction';
import CustomSearchHandler from './leads/_CustomSearchHandler';
import ExportExcelPopUp from './leads/_ExportExcelPopUp';
import ClientAddTreatmentPopup from './clients/_ClientAddTreatmentPopup';
import { setLeadIdForTreatment, setLeadTreatmentPopUp, setLeadTreatmentType, setDocumentLeadTaskUrl, setLeadsData, setRedirectToLeads, setReloadLeads } from './app-context/leadsSlice';
import { TaskDocumentPopup } from './tasks/_TaskDocumentPopup';
import { cloneDeep, set } from 'lodash';
import './leads/leads.css';
import { CustomerCardModel } from './models/CustomerCardModel';

const AllLeadsCopy = () => {
    const dispatch = useDispatch()

    const policyProductionLeadid = useSelector((state: RootState) => state.policyProduction.leadId);
    const offerIdData = useSelector((state: RootState) => state.policyProduction.offerId);
    const idForLeadPopup = useSelector((state: RootState) => state.policyProduction.idForLeadPopup);
    const branchesData = useSelector((state: RootState) => state.policyProduction.branchesData);

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);
    const leadTreatmentPopUp = useSelector((state: RootState) => state.leads.leadTreatmentPopUp);
    const leadTreatmentType = useSelector((state: RootState) => state.leads.leadTreatmentType);
    const documentLeadTaskUrl = useSelector((state: RootState) => state.leads.documentLeadTaskUrl);
    const leadsData = useSelector((state: RootState) => state.leads.leadsData);
    const reloadLeads = useSelector((state: RootState) => state.leads.reloadLeads);
    const redirectToLeads = useSelector((state: RootState) => state.leads.redirectToLeads);
    // Instance variables (previously class properties)
    const simulatorModel = useRef(new SimulatorModel()).current;
    const leadsModel = useRef(new LeadsModel()).current;
    const loginModel = useRef(new LoginModel()).current;
    const generalModel = useRef(new GeneralDataModel()).current;
    const selectedLeadIdRef = useRef<string>('');
    const timeoutId = useRef<any>(null);

    // State variables (converted from this.state)
    const [filter, setFilter] = useState<any>(() => {
        const initialFilter: any = {};
        initialFilter.StatusIdsSearch = [];
        initialFilter.StatusIdSearch = '00000000-0000-0000-0000-000000000000';
        return new LeadFilterModel();
    });
    const [data, setData] = useState<LeadsPageModel | null>(null);
    const [leadsList, setLeadsList] = useState<SPLeadModel[]>([]);
    const [name, setName] = useState<string>("Leads");
    const [IdForPopup, setIdForPopup] = useState<string | null>(null);
    const [userLogged, setUserLogged] = useState<boolean>(true);
    const [leadDocumentUrl, setLeadDocumentUrl] = useState<string | null>(null);
    const [messageContent, setMessageContent] = useState<string | null>(null);
    const [promptContent, setPromptContent] = useState<string | null>(null);
    const [promptTitle, setPromptTitle] = useState<string>('מחיקת ליד');
    const [selectedLead, setSelectedLead] = useState<LeadModel | null>(null);
    const [advancedSearchOpen, setAdvancedSearchOpen] = useState<boolean>(false);
    const [createDateFrom, setCreateDateFrom] = useState<Date | undefined | null>();
    const [createDateTo, setCreateDateTo] = useState<Date | undefined | null>();
    const [closeDateFrom, setCloseDateFrom] = useState<Date | undefined | null>();
    const [closeDateTo, setCloseDateTo] = useState<Date | undefined | null>();
    const [deliveryDateFrom, setDeliveryDateFrom] = useState<Date | undefined | null>();
    const [deliveryDateTo, setDeliveryDateTo] = useState<Date | undefined | null>();
    const [carYear, setCarYear] = useState<Date | undefined | null>();
    const [carYears, setCarYears] = useState<Array<string>>([]);
    const [lastStatusDate, setLastStatusDate] = useState<Date | undefined | null>();
    
    const [AuthorizedToDrive, setAuthorizedToDrive] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [searchStatuses, setSearchStatuses] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
    const [selectedCarYear, setSelectedCarYear] = useState<string>('שנת יצור');
    const [leadStatuses, setLeadStatuses] = useState<any[]>([]);
    const [advSearchOptions, setAdvSearchOptions] = useState<any>({});
    const [LeadTypes, setLeadTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [manufacturer, setManufacturer] = useState<string>('');
    const [manufactures, setManufactures] = useState<any[]>([]);
    const [manufacturesList, setManufacturesList] = useState<any[]>([]);

    const [vehicleModel, setVehicleModel] = useState<string>('');
    const [vehicleSubModel, setVehicleSubModel] = useState<string>('');

    const [VehicleModelAutocomplete, setVehicleModelAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [VehicleModelAll, setVehicleModelAll] = useState<any>([]);
    const [VehicleSubModelAutocomplete, setVehicleSubModelAutocomplete] = useState<Array<AutocompleteData>>([]);
    const [vehicleModels, setVehicleModels] = useState<any[]>([]);
    const [vehicleSubModels, setVehicleSubModels] = useState<any[]>([]);
    const [VehicleSubModelAll, setVehicleSubModelAll] = useState<any[]>([]);
    const [clearFilter, setClearFilter] = useState<boolean>(false);
    const [dataLoaded, setDataLoaded] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 0,
        currentPage: 1,
        totalItems: 0
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [sortLeedsBy, setSortLeedsBy] = useState<any | null>(null);
    const [InsuranceTypes, setInsuranceTypes] = useState<IDNameDescriptionDictionary>(generalSettings.InsuranceTypes);
    const [allBranches, setAllBranches] = useState<any[]>([]);
    const [allUsers, setAllUsers] = useState<any[]>([]);
    const [treeData, setTreeData] = useState<any[]>([]);
    const [treeDataForPopUp, setTreeDataForPopUp] = useState<any[]>([]);
    const [treeDataValue, setTreeDataValue] = useState<string | null>(null);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
    const [openedLeadId, setOpenedLeadId] = useState<string | null>(null);
    const [apiUrl, setApiUrl] = useState<string | null>(localStorage.getItem('apiUrl'));
    const [searchText, setSearchText] = useState<string | undefined>('');
    const [notLogged, setNotLogged] = useState<boolean>(false);
    const [creatorsList, setCreatorsList] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());
    const [LeadTopType, setLeadTopType] = useState<IDNameDescriptionDictionary>({
        '0': { id: 0, name: 'סוג ביטוח', description: 'סוג ביטוח' },
        '1': { id: 1, name: 'רכב', description: 'רכב' },
        '2': { id: 2, name: 'דירה/עסק', description: 'דירה/עסק' },
        '3': { id: 3, name: 'עסק', description: 'עסק' },
        '4': { id: 4, name: 'חיים', description: 'חיים' },
        '5': { id: 5, name: 'בריאות', description: 'בריאות' },
        '6': { id: 6, name: 'אחריות מקצועית', description: 'אחריות מקצועית' },
        '7': { id: 7, name: 'ביטוח חבויות', description: 'ביטוח חבויות' },
        '8': { id: 8, name: 'ביטוח נסיעות לחו"ל', description: 'ביטוח נסיעות לחו"ל' },
        '9': { id: 9, name: 'ביטוח צ.מ.ה', description: 'ביטוח צ.מ.ה' },
        '10': { id: 10, name: 'ביטוח תאונות אישיות', description: 'ביטוח תאונות אישיות' },
        '11': { id: 11, name: 'חקלאי', description: 'חקלאי' },
        '12': { id: 12, name: 'ימי/אווירי', description: 'ימי/אווירי' },
        '13': { id: 13, name: 'כתב שרות', description: 'כתב שרות' },
        '14': { id: 14, name: 'סחורה בהעברה', description: 'סחורה בהעברה' },
        '15': { id: 15, name: 'עובדים זרים', description: 'עובדים זרים' },
        '16': { id: 16, name: 'קבלנים', description: 'קבלנים' },
        '17': { id: 17, name: 'שוק ההון', description: 'שוק ההון' },
        '18': { id: 18, name: 'שוק ההון', description: 'שוק ההון' },
        '19': { id: 19, name: 'הלוואה חברתית', description: 'הלוואה חברתית' },
        '20': { id: 20, name: 'שירותי דרך', description: 'שירותי דרך' },
        '21': { id: 21, name: 'חיות', description: 'חיות' },
        '22': { id: 22, name: 'עמדת טעינה', description: 'עמדת טעינה' }
    });
    const [salesPeopleList, setSalesPeopleList] = useState<any[]>([]);
    const [selectedSaleManName, setSelectedSaleManName] = useState<string | undefined>(undefined);
    // const [leadId, setLeadId] = useState<string | null>(props.leadId);
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [salesPeopleListOrigin, setSalesPeopleListOrigin] = useState<any[]>([]);
    const [treeDataBrunches, setTreeDataBrunches] = useState<any[]>([]);
    const [showExport, setShowExport] = useState<boolean>(false);
    const [documentUrl, setDocumentUrl] = useState<string | null>(null);
    const [isProjectBrunchUser, setIsProjectBrunchUser] = useState<boolean>(false);
    const [oldLeadStatusesList, setOldLeadStatusesList] = useState<any[]>([]);



    // Converted methods to useCallback functions
    const closeNewLead = useCallback((status?: string) => {
        setIdForPopup(null);
        dispatch(setIdForLeadPopup(null));
        if (status && status === 'success') {
            load(filter);
        }
    }, [filter]);

    const closeDocumentPopup = useCallback(() => {
        setLeadDocumentUrl(null);
    }, []);

    const closeMessagePopup = () => {
        setMessageContent(null);
    }

    const closeAdvancedSearch = useCallback(() => {
        setAdvancedSearchOpen(false);
    }, []);

    const setFilterFunc = useCallback((name: string, value: string | null) => {
        if (filter != null) {
            const newFilter = { ...filter };
            newFilter[name] = value;
            setFilter(newFilter);
        }
    }, [filter]);

    const getAuthorizedToDriveName = useCallback((authorizedToDriveId: number) => {
        if (authorizedToDriveId != null) {
            const item = AuthorizedToDrive[authorizedToDriveId];
            if (item != null) {
                return item.description;
            }
        }
    }, [AuthorizedToDrive]);


    // Replace componentDidMount
    useEffect(() => {
        const treeDataInit: any[] = [];
        let loggedUser: any = localStorage.getItem('loggedUser');

        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            setIsAdmin(loggedUser.role === 0 || loggedUser.role === 10);
            console.log("moment(new Date()).tz", moment(new Date()).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0]);

            setTreeData(treeDataInit);
            setTreeDataForPopUp([]);
            setSearchText('');

            init();
        }
    }, []); // Empty dependency array for componentDidMount equivalent

    // Replace componentDidUpdate
    useEffect(() => {
        if (reloadLeads) {
            dispatch(setReloadLeads(false));
            load(filter);
        }
    }, [reloadLeads]); // Dependency on props.reloadLeads


    const init = useCallback(async () => {
        let oldLeadStatusesListTemp = await leadsModel.getOldLeadStatuses();
        console.log('oldLeadStatusesListTemp', oldLeadStatusesListTemp);
        setOldLeadStatusesList(oldLeadStatusesListTemp);

        let loggedUser: any = localStorage.getItem('loggedUser');
        let salesMansList: any[] = [];

        let salesManListStorage: any = localStorage.getItem('handlersList');
        if (salesManListStorage) {
            salesMansList = JSON.parse(salesManListStorage);
        } else {
            salesMansList = await simulatorModel.getCustomerCardHandlers();
            localStorage.setItem('handlersList', JSON.stringify(salesMansList));
        }

        let userListData = localStorage.getItem('usersList');
        if (userListData) {
            const userList = JSON.parse(userListData);
        } else {
            const userList = await leadsModel.customerCardGetUsers();
            localStorage.setItem('usersList', JSON.stringify(userList));
        }

        const allCustomersStorage = sessionStorage.getItem('allCustomers');

        if (!allCustomersStorage) {
            // Fire and forget (non-blocking)
            simulatorModel.customerGetAll()
                .then((customers: any[]) => {
                    if (customers && customers.length > 0) {
                        console.log('lead-customers', customers);
                        const allCustomers = customers.map((u: any) => ({
                            value: u.id,
                            label: u.fullName,
                            identifier: u.identifier
                        }));
                        sessionStorage.setItem('allCustomers', JSON.stringify(allCustomers));
                    }
                })
                .catch((error: any) => {
                    console.error('Failed to fetch customers:', error);
                });
        }

        let agents: any[] = [];
        let agentsFromStorage: any = localStorage.getItem('agents');
        if (agentsFromStorage) {
            agents = JSON.parse(agentsFromStorage);
        } else {
            agents = await simulatorModel.getCustomerCardAgents();
            localStorage.setItem('agents', JSON.stringify(agents));
        }

        if (!loggedUser) {
            loginModel.logOut();
        } else {
            loggedUser = JSON.parse(loggedUser);

            let newAgentsList = agents.filter((a: any) => {
                if (a.parentId) {
                    return a.id === loggedUser.agentId || a.parentId === loggedUser.agentId;
                } else {
                    return a.id === loggedUser.agentId;
                }
            });

            setAgentsList([...newAgentsList]);

            let salesPeoples: any[] = [];
            salesPeoples = salesMansList.map((person: any) => {
                return {
                    label: person.fullName,
                    value: person.id,
                    status: person.status,
                    agentId: person.agentId
                };
            });

            setSalesPeopleList(salesPeoples.filter((sp: any) => sp.agentId === loggedUser.agentId));
            setSalesPeopleListOrigin(salesPeoples);

            // getLeadsAndStatuses
            await getLeadsAndStatuses();

            const lastFilterStr = localStorage.getItem('lastLeadsFilter');
            if (lastFilterStr && lastFilterStr !== '{}') {
                const filterFromStorage = JSON.parse(lastFilterStr);
                if (filterFromStorage.StatusIdsSearch) {
                    let selectedStatusStorage = localStorage.getItem('lastSelectedStatus');
                    if (selectedStatusStorage) {
                        setSelectedStatus(selectedStatusStorage ? JSON.parse(selectedStatusStorage) : []);
                    }
                }
                if (filterFromStorage.searchText) {
                    setSearchText(filterFromStorage.searchText);
                    setFilter(filterFromStorage);
                }

                if (redirectToLeads) {
                    load(filterFromStorage);
                    dispatch(setRedirectToLeads(false));
                } else {
                    loadFromLastFilter(filterFromStorage);
                }
            } else {
                const newFilter: any = {};
                delete newFilter.searchText;
                delete newFilter.BranchType;
                delete newFilter.branchType;
                delete newFilter.BranchId;
                newFilter.StatusIdsSearch = [];
                newFilter.page = 1;

                if (loggedUser) {
                    newFilter.agentId = loggedUser.agentId;

                    if (loggedUser.role === 6 || loggedUser.role === 13) {
                        const currentSaleMan = salesMansList.find((sp: any) => sp.email === loggedUser.email);
                        if (currentSaleMan) {
                            newFilter.salesUserId = currentSaleMan.id;
                        }
                    }
                    load(newFilter);
                }
            }
        }

        // Continue with the rest of the init method...
        const carYearsArray = [];
        carYearsArray.push("שנת יצור");
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            carYearsArray.push(i + "");
        }

        let creatorsListData: any = [];
        const creatorsListFromStorage = localStorage.getItem('creatorsList');
        if (!creatorsListFromStorage) {
            creatorsListData = await generalModel.customerCardGetCreators();
            localStorage.setItem('creatorsList', JSON.stringify(creatorsListData));
        } else {
            creatorsListData = JSON.parse(creatorsListFromStorage);
        }

        const creators = new IDNameDescriptionDictionary();
        creators['0'] = {
            description: 'יוצר הליד',
            name: 'יוצר הליד',
            id: 0
        };
        creatorsListData.forEach((p: any) => {
            creators[p.id] = {
                description: p.fullName,
                name: p.fullName,
                id: p.id,
                active: p.status === 0
            };
        });

        const manufacturesData = await generalModel.getVehicleManufaucters();
        localStorage.setItem('leadsAdvancedSearchOptions', JSON.stringify({
            manufactures: manufacturesData
        }));

        let vehicleModelsData: any = [];
        const vehicleModelsFromStorage = localStorage.getItem('vehicleModels');
        if (vehicleModelsFromStorage) {
            vehicleModelsData = JSON.parse(vehicleModelsFromStorage);
        } else {
            vehicleModelsData = await generalModel.getVehicleModels(undefined);
            localStorage.setItem('vehicleModels', JSON.stringify(vehicleModelsData));
        }

        let vehicleSubModelsData: any = [];
        const vehicleSubModelsFromStorage = localStorage.getItem('vehicleSubModels');
        if (vehicleSubModelsFromStorage) {
            vehicleSubModelsData = JSON.parse(vehicleSubModelsFromStorage);
        } else {
            vehicleSubModelsData = await generalModel.getVehicleSubModels(undefined);
            localStorage.setItem('vehicleSubModels', JSON.stringify(vehicleSubModelsData));
        }

        let subModelsList: any[] = vehicleSubModelsData.filter((sm: any) => sm.text !== null && sm.text !== '');
        subModelsList = subModelsList.map((sm: any) => {
            let label = sm.text.trim();
            if (sm.code && sm.code !== '' && sm.code !== '0') {
                label = `[${sm.code}]${label}`;
            }
            return {
                code: sm.code,
                text: sm.text.trim(),
                label: label,
                value: sm.value
            };
        });

        setManufactures(manufacturesData);
        setManufacturesList(manufacturesData);
        setVehicleModels(vehicleModelsData);
        setVehicleModelAll(vehicleModelsData);
        setVehicleModelAutocomplete(vehicleModelsData);
        setVehicleSubModels(subModelsList);
        setVehicleSubModelAll(subModelsList);
        setVehicleSubModelAutocomplete(subModelsList);
        setLeadTypes(getLeadTypesFunc());
        setCarYears(carYearsArray);
        setCreatorsList(creators);
    }, [leadsModel, simulatorModel, generalModel, loginModel]);




    const getLeadTypesFunc = useCallback((): IDNameDescriptionDictionary => {
        return {
            '0': { description: 'סוג ליד', name: 'סוג ליד', id: -1 },
            '1': { description: 'חדש', name: 'חדש', id: 0 },
            '2': { description: 'משומש', name: 'משומש', id: 2 },
            '3': { description: 'סלקט', name: 'סלקט', id: 1 }
        };
    }, []);


    const onChangePage = (newPage: number) => {
        console.log('onChangePage-newPage', newPage)
        const newPagerConf = { ...pagerConf };
        newPagerConf.currentPage = newPage;
        const newFilter = { ...filter };
        console.log('onChangePage-newFilter.page before', newFilter.page)
        newFilter.page = newPage;
        console.log('onChangePage-newFilter.page after', newFilter.page)

        setCurrentPage(newPage);
        setPagerConf(newPagerConf);
        setFilter(newFilter);
        load(newFilter);
    };
    

    const onStationUserChange = useCallback((data: any) => {
        const newFilter = { ...filter };
        newFilter.BranchId = data.BranchId;
        newFilter.stationUserId = data.stationUserId;
        setFilter(newFilter);

        if (data.BranchId !== undefined || data.stationUserId !== undefined) {
            setClearFilter(false);
        }
    }, [filter]);

    const scrollToLead = useCallback((leadId: string) => {
        const element = document.getElementById(`lead-row-${leadId}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const load = useCallback(async (filterObj?: any) => {
        setLoading(true);
        setLeadsList([]);

        const newStateData: any = {};
        let filterToUse: any = {};

        // console.log('onChangePage load currentPage', currentPage)
        // if (currentPage === 0) {
        //     filterToUse.page = currentPage + 1;
        //     let pagerConfToUse = { ...pagerConf };
        //     pagerConfToUse.currentPage = 1;
        //     setPagerConf(pagerConfToUse);
        //     setCurrentPage(1);
        // }

        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
        }

        if (filterObj) {
            if (savedFilter.searchText && savedFilter.searchText !== "") {
                filterObj["searchText"] = savedFilter.searchText;
            }
            filterToUse = filterObj;
        } else {
            filterToUse = savedFilter;
        }

        if (filterToUse.searchText) {
            setSearchText(filterToUse.searchText);
        }

        if (filterToUse.carYear) {
            setSelectedCarYear(filterToUse.carYear);
        }

        if (filterToUse.salesUserId) {
            const selected = salesPeopleListOrigin.find((sp: any) => sp.value === filterToUse.salesUserId);
            if (selected) {
                setSelectedSaleManName(selected.label);
            }
        }

        if (filterToUse.manufacturerId) {
            const selected = manufacturesList.find((sp: any) => sp.value === filterToUse.manufacturerId);
            if (selected) {
                setManufacturer(selected.text);
            }
        }

        if (filterToUse.stationUserId) {
            const lastTreeDataValue = localStorage.getItem('lastTreeDataValue');
            if (lastTreeDataValue) {
                setTreeDataValue(lastTreeDataValue);
            }
        }

        let allBranchesData = null;
        const branchesAndUsersStorage = localStorage.getItem('branchesAndUsers');
        if (!branchesAndUsersStorage) {
            allBranchesData = await simulatorModel.getBranchesAndUsers();
            localStorage.setItem('branchesAndUsers', JSON.stringify(allBranchesData));
        } else {
            allBranchesData = JSON.parse(branchesAndUsersStorage);
        }

        // Check user permissions and update filter
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser && !filterToUse.stationUserId && !filterToUse.BranchId) {
            loggedUser = JSON.parse(loggedUser);
            if (loggedUser.role === 3 || loggedUser.role === 4) {
                filterToUse.stationUserId = loggedUser.id;
            }

            if (loggedUser.role === 1) {
                if (allBranchesData && allBranchesData.branches && allBranchesData.branches.length > 0) {
                    const branch = allBranchesData.branches.find((b: any) => b.parentId && b.address);
                    if (branch) {
                        filterToUse.BranchId = branch.id;
                        let parentBranch = allBranchesData.branches.find((b: any) => b.id === branch.parentId);
                        dispatch(setBranchesData({ project: parentBranch.name, branch: branch.name, user: '' }));
                    }
                }
            }

            if (loggedUser.role === 2) {
                if (allBranchesData && allBranchesData.branches && allBranchesData.branches.length > 0) {
                    const branch = allBranchesData.branches.find((b: any) => b.parentId === null);
                    if (branch) {
                        filterToUse.BranchId = branch.id;
                        dispatch(setBranchesData({ project: branch.name, branch: '', user: '' }));
                    }
                }
            }
        }

        await buildTreeSelectData(allBranchesData);
        console.log('buildTreeSelectDataForBrunches load');
        await buildTreeSelectDataForBrunches(allBranchesData);

        const savedLeadId = localStorage.getItem('offeredLeadId');
        if (savedLeadId && savedLeadId !== '') {
            setOpenedLeadId(filterToUse.savedLeadId);
        }

        let model: any = {};
        try {
            if (filterToUse.leadType === '-1') {
                filterToUse.leadType = undefined;
            }

            model = await leadsModel.filter(filterToUse);
            dispatch(setLeadsData(JSON.parse(JSON.stringify(model))));

            if (model && model.status && model.status === 401) {
                loginModel.logOut();
                setNotLogged(true);
            }
        } catch (error) {
            model = {
                pageSize: 25,
                currentPage: 1,
                leads: []
            };
        }

        localStorage.setItem('lastLeadsFilter', JSON.stringify(filterToUse));

        if (!data) {
            setTimeout(async () => {
                await getLeadsAndStatuses();
            }, 200);
        }

        const newPagerConf = {
            pageSize: model && model.pageSize ? model.pageSize : 25,
            currentPage: filterObj && filterObj.page > 0 ? filterToUse.page : currentPage,
            totalItems: model && model.allRowsCounter ? model.allRowsCounter : 0
        };

        if (!filterToUse.leadType) {
            filterToUse.leadType = '-1';
        }

        if (model) {
            const authorizedToDriveItem = localStorage.getItem('authorizedToDrive');
            if (!authorizedToDriveItem) {
                const authorizedToDriveData = await simulatorModel.getAuthorizedToDriveItems();
                localStorage.setItem('authorizedToDrive', JSON.stringify(authorizedToDriveData));
                setAuthorizedToDrive(authorizedToDriveData);
            } else {
                const authorizedToDriveData = JSON.parse(authorizedToDriveItem);
                setAuthorizedToDrive(authorizedToDriveData);
            }

            setData(model);
            setLeadsList(model.leads ? model.leads : []);
            setName("Leads");
            setFilter(filterToUse);
            setPagerConf(newPagerConf);
        }

        const insuranceTypesStr = localStorage.getItem('insuranceTypes');
        if (!insuranceTypesStr) {
            const insuranceTypesData = await simulatorModel.getInsuranceTypes();
            localStorage.setItem('insuranceTypes', JSON.stringify(insuranceTypesData));
        }

        if (savedLeadId && savedLeadId !== '') {
            setTimeout(() => {
                scrollToLead(savedLeadId);
                setOpenedLeadId(null);
                localStorage.removeItem('offeredLeadId');
            }, 1000);
        }

        setLoading(false);
        setDataLoaded(true);

        setTimeout(() => {
            setDataLoaded(false);
        }, 100);
    }, [currentPage, salesPeopleListOrigin, manufacturesList, simulatorModel, leadsModel, loginModel, data, scrollToLead]);


    const getLeadsAndStatuses = useCallback(async () => {
        const leadStatusesStorage = localStorage.getItem('leadStatuses');
        let statuses: any[] = [];
        if (!leadStatusesStorage) {
            statuses = await leadsModel.getLeadStatuses();
            localStorage.setItem('leadStatuses', JSON.stringify(statuses));
        } else {
            statuses = JSON.parse(leadStatusesStorage);
        }

        if (statuses) {
            const searchStatusesData = new IDNameDescriptionDictionary();
            searchStatusesData['0'] = {
                description: 'סטטוס',
                name: 'סטטוס',
                id: 0
            };
            searchStatusesData['00000000-0000-0000-0000-000000000000'] = {
                description: 'כל הסגורים',
                name: 'כל הסגורים',
                id: '00000000-0000-0000-0000-000000000000'
            };

            statuses.forEach((status: any) => {
                searchStatusesData[status.value] = {
                    description: status.text,
                    name: status.text,
                    id: status.value
                };
            });

            setSearchStatuses(searchStatusesData);
            setLeadStatuses(statuses);
        }
    }, [leadsModel]);

    const getSubBranches = (branch: any, branches: any[]) => {
        const subBranches = branches.filter((b: any) => b.parentId === branch.id);

        if (subBranches && subBranches.length > 0) {
            subBranches.forEach((b: any) => {
                b.children = getSubBranches(b, branches);
            })
        }
        return subBranches;
    }

    const getBranchesTreeSecond = async (branches: any[]) => {
        if (!branches || branches.length == 0) return [];

        let branchesTree: any[] = [];
        branchesTree = branches.filter((b: any) => b.parentId === null);
        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = getSubBranches(rootBranch, branches);
        });
        return branchesTree;
    };

    const buildTreeNodeBrunches = (id: string, allBranches: any, forPopUp: boolean = false) => {
        const rootBranch = allBranches.branches.find((b: any) => b.id === id);
        const children = allBranches.branches.filter((b: any) => b.parentId === id);
        const nodeTree: any[] = []
        children.forEach((c: any) => {
            const branch: any = {
                title: c.name,
                value: c.id,
                selectable: true,
                type: 'branchId',
                branchManagerId: c.branchManagerId
                // children: []
            }
            if (!branch.children) {
                branch.children = [];
            }
            branch.children = buildTreeNodeBrunches(c.id, allBranches, forPopUp);
            if (c.users) {
                c.users.forEach((u: any) => {
                    const user: any = {
                        title: u.text,
                        value: u.value,
                        type: 'stationUserId',
                    }
                    branch.children.push(user);
                })
            } else if (branch['children'].length == 0) {
                delete branch['children'];
            }
            nodeTree.push(branch);
        })
        return nodeTree;
    }




    const buildTreeSelectDataForBrunches = async (allBranchesData: any) => {
        const treeDataArray: any[] = [];
        const bTree = await getBranchesTreeSecond(allBranchesData.branches);
        bTree.forEach((bItem: any) => {
            const branch: any = {
                title: bItem.name,
                value: bItem.id,
                type: 'branchId',
                children: buildTreeNodeBrunches(bItem.id, allBranchesData)
            };

            treeDataArray.push(branch);
        });

        setTreeDataBrunches(treeDataArray);
    };


    const getBranchesTree = async (allBranches: any[]) => {
        let flag = false;
        if (!allBranches || allBranches.length == 0) return [];
        let branchesTree: any[] = [];

        let role = null;
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            role = loggedUser.role;
        }

        branchesTree = allBranches.filter((b: any) => b.parentId === null);
        console.log('branchesTree 2237', branchesTree)

        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = getSubBranches(rootBranch, allBranches);
        });
        return branchesTree;
    }

    const buildTreeNode = (id: string, allBranches: any, forPopUp: boolean = false) => {
        const children = allBranches.branches.filter((b: any) => b.parentId === id);
        const nodeTree: any[] = []
        children.forEach((c: any) => {
            const branch: any = {
                title: c.name,
                value: c.id,
                selectable: !forPopUp,
                type: 'branchId',
                branchManagerId: c.branchManagerId
                // children: []
            }
            if (!branch.children) {
                branch.children = [];
            }
            branch.children = buildTreeNode(c.id, allBranches, forPopUp);
            if (c.users) {
                c.users.forEach((u: any) => {
                    const user: any = {
                        title: u.text,
                        value: u.value,
                        type: 'stationUserId',
                    }
                    branch.children.push(user);
                })
            }

            const branchUsers = allBranches.users.filter((u: any) => u.branchId === c.id);
            if (branchUsers && branchUsers.length > 0) {
                branchUsers.forEach((bUser: any) => {
                    branch.children.push({
                        title: bUser.fullName,
                        value: bUser.id,
                        type: 'stationUserId',
                    })
                });
            }

            const branchManager = allBranches.users.find((u: any) => u.id === c.branchManagerId);
            if (branchManager) {
                if (!branch.children) {
                    branch.children = [];
                }
                branch.children.push({
                    title: branchManager.fullName,
                    value: branchManager.id,
                    type: 'stationUserId',
                })
            }
            nodeTree.push(branch);
        })
        return nodeTree;
    }

    const buildTreeSelectData = useCallback(async (allBranchesData: any) => {
        const treeDataArray: any[] = [];
        const treeDataForPopUpArray: any[] = [];

        treeDataArray.push(
            { value: '1', title: 'חדש', type: 'branchType' },
            { value: '2', title: 'משומש', type: 'branchType' },
            { value: '3', title: 'סלקט', type: 'branchType' }
        );

        const bTree = await getBranchesTree(allBranchesData.branches);
        bTree.forEach((bItem: any) => {
            const branch: any = {
                title: bItem.name,
                value: bItem.id,
                type: 'branchId',
                children: buildTreeNode(bItem.id, allBranchesData)
            };

            const branchforPopUp: any = {
                title: bItem.name,
                value: bItem.id,
                type: 'branchId',
                selectable: false,
                children: buildTreeNode(bItem.id, allBranchesData, true)
            };

            const rootBranchManager = allBranchesData.users.find((u: any) => u.id === bItem.branchManagerId);
            if (rootBranchManager) {
                if (!branch.children) {
                    branch.children = [];
                }
                branch.children.push({
                    title: rootBranchManager.fullName,
                    value: rootBranchManager.id,
                    type: 'stationUserId',
                });
                if (!branchforPopUp.children) {
                    branchforPopUp.children = [];
                }
                branchforPopUp.children.push({
                    title: rootBranchManager.fullName,
                    value: rootBranchManager.id,
                    type: 'stationUserId',
                });
            }
            treeDataArray.push(branch);
            treeDataForPopUpArray.push(branchforPopUp);
        });

        setTreeData(treeDataArray);
        setTreeDataForPopUp(treeDataForPopUpArray);
        setAllBranches(allBranchesData.branches);
        setAllUsers(allBranchesData.users);
    }, []);

    const newLead = useCallback(() => {
        const newLeadId = "0";
        setIdForPopup(newLeadId);
    }, []);

    const editLead = useCallback((selectedId: string) => {
        if (data && data.leads) {
            const leads = data.leads;
            const leadData = leads.find(
                (lead: SPLeadModel) => lead.lead && lead.lead.id === selectedId
            );
            if (leadData && leadData.lead) {
                setSelectedLead(leadData.lead);
                setIdForPopup(selectedId);
            }
        }
    }, [data]);

    const onDeleteLead = useCallback(async (selectedId: string) => {

        //await customerCardModel.deleteAssigment(id);

        let lead = leadsList.find((l: any) => l.lead.id === selectedId);
        if (lead && lead.lead) {
            let treatmentList = lead.lead.treatments;
            if (treatmentList && treatmentList.length > 0) {
                for (let i = 0; i < treatmentList.length; i++) {
                    const treatment = treatmentList[i];
                    await new CustomerCardModel().deleteAssigment(treatment.id || '');
                }
            }
        }

        await leadsModel.leadsDelete(selectedId);
        load(filter);
    }, [leadsModel, filter, load]);

    const openDeletePropmpt = useCallback((selectedId: string) => {
        setSelectedLeadId(selectedId);
        openPromptPopUp('האם את/אתה בטוח/ה?', 'מחיקת ליד');
    }, []);

    const openPromptPopUp = useCallback((promptText: string, propmptTitle: string) => {
        setPromptContent(promptText);
        setPromptTitle(propmptTitle);
    }, []);

    const onPromptApprove = useCallback(() => {
        if (selectedLeadId) {
            onDeleteLead(selectedLeadId);
        }
        setPromptContent(null);
    }, [selectedLeadId, onDeleteLead]);

    const loadFromLastFilter = useCallback(async (filterObj?: any) => {
        setLoading(true);
        setLeadsList([]);

        const newStateData: any = {};
        let filterToUse: any = {};

        console.log('onChangePage loadFromLastFilter currentPage', currentPage)
        if (currentPage == 0) {
            filterToUse.page = currentPage + 1;
            let pagerConfToUse = { ...pagerConf };
            pagerConfToUse.currentPage = 1;
            console.log('onChangePage loadFromLastFilter currentPage inside pagerConfToUse, filterToUse.page', pagerConfToUse, filterToUse.page)
            setPagerConf(pagerConfToUse);
            setCurrentPage(1);
        }

        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
        }

        if (filterObj) {
            if (savedFilter.searchText && savedFilter.searchText !== "") {
                filterObj["searchText"] = savedFilter.searchText;
            }
            filterToUse = filterObj;
        } else {
            filterToUse = savedFilter;
        }

        if (filterToUse.searchText) {
            setSearchText(filterToUse.searchText);
        }

        if (filterToUse.carYear) {
            setSelectedCarYear(filterToUse.carYear);
        }

        if (filterToUse.salesUserId) {
            const selected = salesPeopleListOrigin.find((sp: any) => sp.value === filterToUse.salesUserId);
            if (selected) {
                setSelectedSaleManName(selected.label);
            }
        }

        if (filterToUse.manufacturerId) {
            const selected = manufacturesList.find((sp: any) => sp.value === filterToUse.manufacturerId);
            if (selected) {
                setManufacturer(selected.text);
            }
        }

        if (filterToUse.stationUserId) {
            const lastTreeDataValue = localStorage.getItem('lastTreeDataValue');
            if (lastTreeDataValue) {
                setTreeDataValue(lastTreeDataValue);
            }
        }

        // Storage of branchesAndUsers types
        let allBranchesStorageData = null;
        const branchesAndUsersStorage = localStorage.getItem('branchesAndUsers');
        if (!branchesAndUsersStorage) {
            allBranchesStorageData = await simulatorModel.getBranchesAndUsers();
            localStorage.setItem('branchesAndUsers', JSON.stringify(allBranchesStorageData));
        } else {
            allBranchesStorageData = JSON.parse(branchesAndUsersStorage);
        }

        await buildTreeSelectData(allBranchesStorageData);
        console.log('buildTreeSelectDataForBrunches loadFromLastFilter');
        await buildTreeSelectDataForBrunches(allBranchesStorageData);

        const savedLeadId = localStorage.getItem('offeredLeadId');
        if (savedLeadId && savedLeadId !== '') {
            setOpenedLeadId(filterToUse.savedLeadId);
        }

        let model: any = {};
        try {
            if (filterToUse.leadType === '-1') {
                filterToUse.leadType = undefined;
            }

            // The key difference: check if we already have cached leads data first
            if (leadsData && leadsData.leads.length > 0) {
                model = { ...leadsData };
            } else {
                model = await leadsModel.filter(filterToUse);
                dispatch(setLeadsData(JSON.parse(JSON.stringify(model))));
            }

            if (model && model.status && model.status === 401) {
                loginModel.logOut();
                setNotLogged(true);
            }
        } catch (error) {
            model = {
                pageSize: 25,
                currentPage: 1,
                leads: []
            };
        }

        localStorage.setItem('lastLeadsFilter', JSON.stringify(filterToUse));

        if (!data) {
            setTimeout(async () => {
                await getLeadsAndStatuses();
            }, 200);
        }

        const newPagerConf = {
            pageSize: model && model.pageSize ? model.pageSize : 25,
            currentPage: filterObj && filterObj.page > 0 ? filterToUse.page : currentPage,
            totalItems: model && model.allRowsCounter ? model.allRowsCounter : 0
        };

        if (!filterToUse.leadType) {
            filterToUse.leadType = '-1';
        }

        if (model) {
            const authorizedToDriveItem = localStorage.getItem('authorizedToDrive');
            if (!authorizedToDriveItem) {
                const authorizedToDriveData = await simulatorModel.getAuthorizedToDriveItems();
                localStorage.setItem('authorizedToDrive', JSON.stringify(authorizedToDriveData));
                setAuthorizedToDrive(authorizedToDriveData);
            } else {
                const authorizedToDriveData = JSON.parse(authorizedToDriveItem);
                setAuthorizedToDrive(authorizedToDriveData);
            }

            setData(model);
            setLeadsList(model.leads ? model.leads : []);
            setName("Leads");
            setFilter(filterToUse);
            setPagerConf(newPagerConf);
        }

        // Storage of insurance types
        const insuranceTypesStr = localStorage.getItem('insuranceTypes');
        if (!insuranceTypesStr) {
            const insuranceTypesData = await simulatorModel.getInsuranceTypes();
            localStorage.setItem('insuranceTypes', JSON.stringify(insuranceTypesData));
        }

        if (savedLeadId && savedLeadId !== '') {
            setTimeout(() => {
                scrollToLead(savedLeadId);
                setOpenedLeadId(null);
                localStorage.removeItem('offeredLeadId');
            }, 1000);
        }

        setLoading(false);
        setDataLoaded(true);

        setTimeout(() => {
            setDataLoaded(false);
        }, 100);
    }, [
        currentPage,
        salesPeopleListOrigin,
        manufacturesList,
        simulatorModel,
        leadsModel,
        loginModel,
        data,
        scrollToLead,
        buildTreeSelectData,
        buildTreeSelectDataForBrunches,
        getLeadsAndStatuses
    ]);

    const findSubModelByText = (searchTxt: any) => {
        let selectedSubModel: any = VehicleSubModelAll.find((m: any) => m.label === searchTxt);
        if (selectedSubModel) {
            return selectedSubModel;
        } else return null;
    }

    const prepareFilterData = (filterData?: any) => {
        let new_filter = filterData ? filterData : { ...filter };
        if (!new_filter.page) {
            new_filter.page = 1;
        }
        if (new_filter.searchText) {
            new_filter.searchText = new_filter.searchText.trim();
        }
        if (new_filter.leadType == '-1') {
            new_filter.leadType = undefined;
        }
        if (new_filter.policyType == '0') {
            new_filter.policyType = undefined;
        }
        if (new_filter.vehicleModel == '') {
            new_filter.vehicleModel = undefined
        }
        if (new_filter.vehicleSubModel == '') {
            new_filter.vehicleSubModel = undefined
        } else {
            if (new_filter.vehicleSubModelId == '') {
                const submodelObj = findSubModelByText(new_filter.vehicleSubModel);
                if (submodelObj) {
                    new_filter.vehicleSubModelId = submodelObj.value;
                    new_filter.vehicleSubModel = undefined;
                } else {
                    new_filter.vehicleSubModel = undefined;
                    new_filter.vehicleSubModelId = undefined
                }
            }
        }
        return new_filter;
    }

    const doFilter = async () => {
        let filter = prepareFilterData();

        let data = new LeadsPageModel();
        setData(data);
        await load(filter);

        // this.setState({
        //   data: new LeadsPageModel()
        // }, () => this.load(filter))
    };


    const clearFilterValue = (name: string) => {
        var new_filter = { ...filter };
        new_filter[name] = null;

        switch (name) {
            case 'searchText':
                new_filter[name] = '';
                setSearchText('');
                const lastFilterStr = localStorage.getItem('lastLeadsFilter');
                let savedFilter: any = {};
                if (lastFilterStr && lastFilterStr !== '{}') {
                    savedFilter = JSON.parse(lastFilterStr);
                    savedFilter.searchText = '';
                    localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
                }
                break;
            case 'manufacturerId':
                // this.setState({manufacturer: ''})
                const mList = vehicleModels
                setManufacturer('');
                setVehicleModelAutocomplete([]);
                setVehicleModelAll(mList);

                new_filter.vehicleModelId = null;
                new_filter.vehicleModel = '';
                break;

            default:
                break;
        }
        setFilter(new_filter);
    }

    const handleSearchChange = async (name: string, event: any) => {
        var new_filter = { ...filter };
        const newSearchValue = event.target.value;
        if (new_filter[name] !== newSearchValue) {

            new_filter[name] = newSearchValue;
            // await this.setState({ new_filter: new_filter, searchText: newSearchValue });
            setFilter(new_filter);
            setSearchText(newSearchValue);

            const lastFilterStr = localStorage.getItem('lastLeadsFilter');
            let savedFilter: any = {};
            if (lastFilterStr && lastFilterStr !== '{}') {
                savedFilter = JSON.parse(lastFilterStr);
                savedFilter.searchText = newSearchValue;
                localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
            }

        }
        if (newSearchValue === '') {
            clearFilterValue('searchText')
        }
    };

    const setStateData = (name: string, value: any) => {
        console.log(name, value);
        const filter_new = { ...filter };
        filter_new[name] = value;
        // this.setState({ filter: filter_new });
        setFilter(filter_new);
    }

    const clearDate = (dateName: string) => {
        switch (dateName) {
            case 'createDateFrom':
                setCreateDateFrom(undefined);
                break;
            case 'createDateTo':
                setCreateDateTo(undefined);
                break;
            case 'closeDateFrom':
                setCloseDateFrom(undefined);
                break;
            case 'closeDateTo':
                setCloseDateTo(undefined);
                break;
            case 'deliveryDateFrom':
                setDeliveryDateFrom(undefined);
                break;
            case 'deliveryDateTo':
                setDeliveryDateTo(undefined);
                break;
            default:
                break;
        }

        setStateDataAndFilter(dateName, null);
    }

    const setStateDataAndFilter = (name: string, value: any) => {
        const filter_new = { ...filter };
        // this.setStateData(name, value);
        if (name == "carYear" && value == "בחר") {
            value = undefined;
        } else {
            switch (name) {
                case 'createDateFrom':
                    filter.createDateFrom = value;
                    break;
                case 'createDateTo':
                    filter.createDateTo = value;
                    break;
                case 'closeDateFrom':
                    filter.closeDateFrom = value;
                    break;
                case 'closeDateTo':
                    filter.closeDateTo = value;
                    break;
                case 'deliveryDateFrom':
                    filter.deliveryDateFrom = value;
                    break;
                case 'deliveryDateTo':
                    filter.deliveryDateTo = value;
                    break;

                default:
                    break;
            }
        }
        filter_new[name] = value;
        setFilter(filter_new);
    }


    const onStatusChange2 = (values: string[]) => {

        if (values.length > 0 && values[values.length - 1] == '0') {
            values = [];
        }


        var allClosed = '00000000-0000-0000-0000-000000000000';
        if (values.length > 0 && values[values.length - 1] == allClosed) {
            values = [allClosed];
        }
        else if (values.some((x: string) => x === allClosed)) {
            values = values.filter(x => x !== allClosed);
        }

        console.log("onStatusChange2-values", values)
        const stringIds = values.map(v => String(v));

        const nextFilter = { ...filter };
        const searchStatusesTemp = { ...searchStatuses };

        console.log('onStatusChange2-stringIds', stringIds)
        if (stringIds.length === 0) {
            delete nextFilter.StatusIdsSearch;
        } else {
            if (values.some((x: string) => x === allClosed)) {
                nextFilter.allClosed = true;
                delete nextFilter.StatusIdsSearch;
            }
            else {
                nextFilter.StatusIdsSearch = stringIds; // array of string
            }
        }
        console.log('onStatusChange2-nextFilter', nextFilter)
        // optional: store names for UX/debug
        const options = Array.isArray(searchStatusesTemp)
            ? searchStatusesTemp
            : Object.values(searchStatusesTemp);

        const selectedNames: string[] = [];
        for (let i = 0; i < stringIds.length; i++) {
            const id = stringIds[i];
            const found = options.find(o => String(o.id) === id);
            console.log('onStatusChange2-found', found)
            if (found && typeof found.name === "string") {
                selectedNames.push(found.id);
            }
        }
        console.log('onStatusChange2-selectedNames', selectedNames)

        localStorage.setItem("lastSelectedStatus", JSON.stringify(selectedNames));

        setFilter(nextFilter);
        setSelectedStatus(selectedNames);

    }

    const onPolicyTypeChange = (name: string, value: any) => {
        setStateData(name, value);
        // setStateData('leadType', '-1');
    }

    const closePromptPopup = () => {
        setPromptContent(null);
    }

    const closeShowExport = () => {
        // this.setState({ showExport: false });
        setShowExport(false);
    }

    const onLeadTypeChange = (name: string, value: any) => {
        setStateData(name, value);
        if (value === '-1') {
            value = undefined;
        } else {
        }

        // this.filter(name, value);
    }

    const onManufacturerSelect = async (id: string) => {
        if (id) {
            // this.setStateData("manufacturer", selectedManufacturer.text);
            // this.setStateData("manufacturerId", selectedManufacturer.value);
            let data = await generalModel.getVehicleModels(id);
            const models = data.filter((i: any) => i.text !== null);

            data = await generalModel.getVehicleSubModelsByManufacturer(id);

            const subModelsList = data.filter((sm: any) => sm.label !== null && sm.label !== '').map((sm: any) => {
                let label = sm.label.trim();
                if (sm.code && sm.code !== '' && sm.code !== '0') {
                    label = `[${sm.code}]${label}`;
                }
                return {
                    code: sm.code,
                    text: sm.label.trim(),
                    label: label,
                    value: sm.val
                }
            })

            setVehicleModelAutocomplete(models);
            setVehicleModelAll(models);
            setVehicleSubModelAutocomplete(subModelsList);

        } else {

        }
    }

    const onManufacturerChange = (e: any) => {
        const search = e.target.value;
        // this.setState({ manufacturer: search });
        setManufacturer(search);
        // this.setStateData('manufacturer', search);
        const manufacturer: any = manufactures.find((e: any) => e.text === search);
        if (manufacturer) {
            // this.setState(manufacturerId: (manufacturer as any).value);
            // this.setState({ manufacturer: (manufacturer as any).text });
            setManufacturer((manufacturer as any).text);
            const filterTemp = { ...filter };
            filterTemp['manufacturerId'] = (manufacturer as any).value;
            setFilter(filterTemp);
            onManufacturerSelect((manufacturer as any).value);
        } else {
            const mList = vehicleModels
            // this.setState({
            //     VehicleModelAutocomplete: mList,
            //     VehicleModelAll: mList
            // });
            setVehicleModelAutocomplete(mList);
            setVehicleModelAll(mList);

        }
    }

    const onModelChange = (e: any) => {
        const search = e.target.value;
        //console.log('onModelChange', search, this.state.VehicleModelAll);
        // setStateData('vehicleModel', search);
        setVehicleModel(search);

        const selectedModel: any = VehicleModelAll.find((m: any) => m.text === search);
        console.log('onModelChange-selectedModel', selectedModel)
        if (selectedModel) {
            onModelSelect(selectedModel.value);
            // setFilter('vehicleModelId', selectedModel.value);
            const filterTemp = { ...filter };
            filterTemp['vehicleModelId'] = selectedModel.value;
            filterTemp['vehicleModel'] = selectedModel.text;
            setFilter(filterTemp);
            //console.log('onModelChange', search, selectedModel);
        } else {
            const filterTemp = { ...filter };
            filterTemp['vehicleModelId'] = null;
            setFilter(filterTemp);
        }
        // const models = VehicleModelAll.filter(
        //     (m: any) => {
        //         return m.text != null && m.text.indexOf(search) > -1
        //     }
        // );
        // this.setState({
        //     VehicleModelAutocomplete: models
        // });
    }

    const onModelSelect = async (id: string) => {
        if (id) {
            const selectedModel: any = VehicleModelAll.find((m: any) => m.value === id);

            var data = await generalModel.getVehicleSubModels(id);
            data.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);

            const subModelsList = data.map((sm: any) => {
                let label = sm.text.trim();
                if (sm.code && sm.code !== '' && sm.code !== '0') {
                    label = `[${sm.code}]${label}`;
                }
                return {
                    code: sm.code,
                    text: sm.text.trim(),
                    label: label,
                    value: sm.value
                }
            })

            setVehicleSubModelAutocomplete(subModelsList);
        } else {
            setStateData("manufacturer", null);
            const smList = vehicleSubModels

            setVehicleSubModelAutocomplete(smList);
            setStateData("vehicleModel", "");

        }
    }

    const onSubModelSelect = (id: string) => {
        if (id) {
            const selectedModel: any = VehicleSubModelAll.find((m: any) => m.value === id);
            setStateData("vehicleSubModel", selectedModel.text);
            setStateData("vehicleSubModelId", id);
        } else {
            setStateData("vehicleSubModel", '');
            setStateData("vehicleSubModelId", '');
        }
    }


    const onSubModelChange = (e: any) => {
        const search = e.target.value;
        // setStateData('vehicleSubModel', search);
        
        // setVehicleSubModel(search);
        let selectedSubModel: any = findSubModelByText(search);
        console.log('onSubModelChange-selectedSubModel', selectedSubModel)
        setVehicleSubModel(search);

        const new_filter = { ...filter };
        new_filter['vehicleSubModel'] = search;
        if (selectedSubModel) {
            onSubModelSelect(selectedSubModel.value);
            // this.setFilter('vehicleSubModelId', selectedSubModel.value);
            new_filter['vehicleSubModelId'] = selectedSubModel.value;
        } else {
            // this.setFilter('vehicleSubModelId', '');
            new_filter['vehicleSubModelId'] = '';
        }
        setFilter(new_filter);
        const subModels = VehicleSubModelAll.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(search) > -1
            }
        );
    }

    const onCarYearChange = (value: string) => {
        const new_filter = { ...filter };
        new_filter.carYear = value === 'שנת יצור' ? undefined : value


        setFilter(new_filter);
        setSelectedCarYear(value);
    }

    const onAgentChange = (value: string) => {
        const new_filter = { ...filter };
        new_filter['agentId'] = value;

        let salesMansListByAgent = salesPeopleListOrigin.filter((sm) => sm.agentId == value)
        // this.setState({
        //   filter,
        //   salesPeopleList: salesMansListByAgent,
        // });
        setFilter(new_filter);
        setSalesPeopleList(salesMansListByAgent);

    }

    const onSalesManSelect = (value: any) => {
        const search = value;
        // this.setState({ selectedSaleManName: search });
        setSelectedSaleManName(search);
        console.log('this.state.salesPeopleList', salesPeopleList)
        const selected = salesPeopleList.find((sp: any) => sp.label == search);
        console.log('selected', selected)
        if (selected) {
            // this.setState({ selectedSaleManName: selected.label });
            setStateData('salesUserId', selected.value);
        } else {
            // this.setState({ selectedSaleManName: undefined });
            setStateData('salesUserId', undefined);
        }
    }

    const onClearSalesManSelect = () => {
        clearValue('salesUserId')
    }


    const clearValue = (name: string) => {
        const new_filter = { ...filter };
        new_filter[name] = '';
        switch (name) {
            case 'manufacturerId':
                setStateData("manufacturer", "");

                //need to check with Rivka
                setStateData("vehicleModel", "");
                setVehicleModel('');
                let vListModel = vehicleModels
                setVehicleModelAutocomplete(vListModel);
                setVehicleModelAll(vListModel);


                new_filter.vehicleModelId = undefined;
                new_filter.vehicleModel = '';
                new_filter.manufacturerId = undefined;
                new_filter.vehicleSubModelId = undefined;
                new_filter.vehicleSubModel = '';
                // filter(name, null);
                break;
            case 'vehicleModelId':
                setStateData("vehicleModel", "");
                setVehicleModel('');
                const mList = vehicleSubModels
                
                // this.setState({
                //     VehicleSubModelAll: mList,
                //     VehicleSubModelAutocomplete: mList
                // });
                setVehicleSubModelAll([]);
                // need to check with Rivka
                setVehicleSubModelAutocomplete(mList);
                new_filter.vehicleSubModelId = undefined;
                new_filter.vehicleSubModel = '';
                new_filter.vehicleModel = null;

                if (new_filter.manufacturerId && new_filter.manufacturerId !== '') {
                    onManufacturerSelect(new_filter.manufacturerId);
                }
                // this.filter(name, null);
                break;
            case 'vehicleSubModelId':
                setVehicleSubModel('');
                setStateData("vehicleSubModel", '');
                const smList = vehicleSubModels
                // this.setState({
                //     VehicleSubModelAll: smList,
                //     VehicleSubModelAutocomplete: smList
                // });
                new_filter.vehicleSubModelId = undefined;
                new_filter.vehicleSubModel = '';

                // setVehicleSubModelAll(smList);
                // need to check with Rivka
                setVehicleSubModelAutocomplete(smList);
                if (new_filter.vehicleSubModelId && new_filter.vehicleSubModelId !== '') {
                    onSubModelSelect(new_filter.vehicleSubModelId);
                } else {
                    if (new_filter.manufacturerId && new_filter.manufacturerId !== '') {
                        onManufacturerSelect(new_filter.manufacturerId);
                    }
                }
                break;
            case 'carYear':
                setStateData("vehicleSubModel", '');
                // this.filter(name, undefined);
                break;
            case 'salesUserId': {
                new_filter.salesUserId = undefined;
                // this.setState({
                //     selectedSaleManName: undefined
                // });
                setSelectedSaleManName(undefined);
                break;
            }
            default:
                // selectedSaleManName
                // this.filter(name, null);
                break;
        }
        // this.setState({ new_filter: new_filter });
        setFilter(new_filter);
        //console.log('filter', filter)
    }


    const sortLeadsBy = (name: string) => {
        let allLeads: SPLeadModel[] = [];
        let sortLeedsBy_temp: any = sortLeedsBy ? sortLeedsBy : {
            name: '',
            direction: 'ASC'
        };
        let new_filter = { ...filter };
        if (sortLeedsBy_temp.name == name && sortLeedsBy_temp.direction == 'DESC') {
            new_filter.SortBy = undefined;
            sortLeedsBy_temp = null;
        } else {
            allLeads = leadsList;
            if (sortLeedsBy_temp.name != name) {
                sortLeedsBy_temp.name = name;
                sortLeedsBy_temp.direction = 'ASC';
            } else {
                if (sortLeedsBy_temp.direction == 'DESC') {
                    sortLeedsBy_temp.direction = 'ASC';
                } else {
                    sortLeedsBy_temp.direction = 'DESC';
                }
            }

            new_filter.SortBy = [{
                Property: sortLeedsBy_temp.name,
                SortDirection: sortLeedsBy_temp.direction == 'ASC' ? 0 : 1
            }]


        }
        // this.setState({
        //   new_filter: new_filter,
        //   sortLeedsBy: sortLeedsBy
        // });
        setFilter(new_filter);
        setSortLeedsBy(sortLeedsBy_temp);

        load(new_filter)

    }

    const openPopupMessage = (data: any) => {
        //console.log('messageContent', data.response);
        if (data && data.response && typeof data.response !== 'undefined') {
            // this.setState({ messageContent: data.response });
            setMessageContent(data.response);
        }
    }

    const onLoggedUserChange = (status: boolean) => {
        // this.setState({ userLogged: status });
        setUserLogged(status);
    }

    const openDocumentPopup = (docUrl: string) => {
        const fileUrl = `${apiUrl}${docUrl}`;
        // this.setState({ leadDocumentUrl: fileUrl });
        setLeadDocumentUrl(fileUrl);
    }

    const openMessagePopUp = (popUpText: string) => {
        console.log('openMessagePopUp', popUpText)
        setMessageContent(popUpText);
    }

    const updateLeadStatus = async (leadId: string, newStatusId: string) => {
        try {
            const leadsListCopy = [...leadsList];
            const leadIndex = leadsListCopy.findIndex((l: any) => l.lead.id == leadId);
            if (leadIndex > -1) {
                const newStatus = leadStatuses.find((ls: any) => ls.value == newStatusId);
                if (newStatus) {
                    leadsListCopy[leadIndex].lastStatusId = newStatus.value;
                    leadsListCopy[leadIndex].lastStatusName = newStatus.text;
                }
                setLeadsList(leadsListCopy);
            }
            const res = await leadsModel.updateLeadStatus({
                Id: leadId,
                LastStatusId: newStatusId
            });

            console.log('updateLeadStatus res', res);
            if (newStatusId === 'c5e660ec-c3e3-44c7-b881-90671d077731') {
                var assigment = await new CustomerCardModel().treatmentsForUpsert({
                    "TreatmentType": 1
                })
                if (assigment && assigment.id) {
                    assigment.leadRelatedId = leadId;
                    assigment.topic = "ליד הועבר לחיתום";
                    assigment.belongsToId = "d7da0d13-2ac9-4f2f-ebe1-08dab5898538";
                    assigment.endDate = new Date(moment(new Date).add(1, 'days').format('YYYY-MM-DDTHH:mm'));
                    assigment.alertDate = new Date(moment(new Date).format('YYYY-MM-DDTHH:mm'));
                    // assigment.assignmentStatusId = "45cb3c16-f64f-40d5-9863-42a742ce4624"
                    try {
                        let res = await new CustomerCardModel().upsertAssignment(assigment);
                        console.log('upsertAssignment-change-status res', res);
                    } catch (err) {
                        console.error('Failed to upsert assignment after lead status change', err);
                    }
                }
            }

        } catch (error) {
            console.error('Failed to update lead status', error);
        }
    }

    const onGoToSimulatorClick = (selectedId: string) => {
        localStorage.setItem('lastLeadsFilter', JSON.stringify(filter));
    }

    const checkPermissionsOfCreator = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');

            if (moodelPermision && moodelPermision.permissionType == 2) {
                return true;
            }
        }
        return false;
    }

    const checkPermissionsOfEdit = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Leads');

            if (moodelPermision && moodelPermision.permissionType == 2 && (loggedUser.role < 1 || loggedUser.role > 5)) {
                return true;
            }
        }
        return false;
    }


    const clearFilterAll = async () => {
        // const currFilter = this.state.filter;
        const filter: any = {};

        filter.StatusIdsSearch = [];
        filter.StatusIdSearch = undefined;
        filter.vehicleModel = '';
        filter.vehicleSubModel = '';
        filter.leadType = '-1';
        filter.policyType = undefined;
        filter.page = 1;

        const loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const loggedUserObj = JSON.parse(loggedUser);
            if (loggedUserObj.role == 1) {
                dispatch(setBranchesData({ project: branchesData.project, branch: branchesData.branch, user: '' }));
            } else if (loggedUserObj.role == 2) {
                dispatch(setBranchesData({ project: branchesData.project, branch: '', user: '' }));
            } else {
                dispatch(setBranchesData({ project: '', branch: '', user: '' }));
            }
        }
        localStorage.removeItem('lastSelectedStatus');


        const lastFilterStr = localStorage.getItem('lastLeadsFilter');
        let savedFilter: any = {};
        if (lastFilterStr && lastFilterStr !== '{}') {
            savedFilter = JSON.parse(lastFilterStr);
            savedFilter.searchText = '';
            savedFilter.StatusIdsSearch = [];

            localStorage.setItem('lastLeadsFilter', JSON.stringify(savedFilter));
        }

        let pagger = cloneDeep(pagerConf);
        pagger.currentPage = 1;


        setFilter(filter);
        setClearFilter(true);
        setTreeDataValue('');
        setSearchText('');
        setSelectedSaleManName(undefined);
        setOpenedLeadId(null);
        setSelectedStatus([]);
        setSelectedCarYear('שנת יצור');
        setManufacturer('');
        setVehicleModel('');
        setVehicleSubModel('');

        // need to check with Rivka
        const mList = vehicleSubModels
        setVehicleSubModelAutocomplete(mList);
        
        setPagerConf(pagger);
        setCurrentPage(0);

        let filterToLoad = prepareFilterData(filter);

        await load(filterToLoad);

    }

    const onHideDocumentPopUp = () => {
        dispatch(setDocumentLeadTaskUrl([]));
    }

    const setLeadtreatmentOff = () => {
        dispatch(setLeadTreatmentPopUp(false));
        dispatch(setLeadIdForTreatment(""));
        dispatch(setLeadTreatmentType(0));
    }

    const showExportModel = () => {
        setShowExport(true);
    }

    const hasPermissionToExport = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            if(loggedUser.role == 0 || loggedUser.role == 7 || loggedUser.role == 10){
                return true;
            }
        }
        return false;     
    }


    const lead = leadsList && leadsList.length > 0 && leadsList.find((lead: any) => lead && lead.lead && lead.lead.id === policyProductionLeadid);
    const offer = lead && lead.lead && lead.lead.offers && lead.lead.offers.find((offer) => offer.id === offerIdData);

    const options = (Array.isArray(searchStatuses)
        ? searchStatuses
        : Object.values(searchStatuses)
    ).map(opt => ({
        label: opt.name,
        value: String(opt.id),
    }));

    return (<div className="App">
        {
            IdForPopup != null || idForLeadPopup != null ?
                (
                    <LeadPopup
                        id={IdForPopup}
                        ClosePopup={closeNewLead}
                        leadData={selectedLead}
                        treeData={treeDataForPopUp}
                        treeDataBrunches={treeDataBrunches}
                    />
                ) : ""
        }
        {
            leadDocumentUrl != null ?
                (
                    <LeadDocumentPopup
                        ClosePopup={closeDocumentPopup}
                        documentUrl={leadDocumentUrl}
                    />
                ) : ""
        }
        {
            messageContent != null && messageContent != '' ?
                (
                    <LeadMessagePopup
                        ClosePopup={() => closeMessagePopup()}
                        messageContent={messageContent}
                    />
                ) : ""
        }
        {
            promptContent != null && promptContent != '' ?
                (
                    <LeadMessagePopup
                        ClosePopup={() => closePromptPopup()}
                        OnApprove={() => onPromptApprove()}
                        approveBtnTitle={'מחק'}
                        messageContent={promptContent}
                        messageTitle={promptTitle}
                    />
                ) : ""
        }
        {showExport && treeDataBrunches && agentsList && salesPeopleList &&
            <ExportExcelPopUp
                treeDataBrunches={treeDataBrunches}
                allBranches={allBranches}
                allUsers={allUsers}
                saveState={dataLoaded}
                ClosePopup={() => closeShowExport()}
                leadsFilter={filter}
                searchStatuses={searchStatuses}
                LeadTopType={LeadTopType}
                LeadTypes={LeadTypes}
                manufacturesList={manufacturesList}
                manufactures={manufactures}
                vehicleModels={vehicleModels}
                VehicleSubModelAll={VehicleSubModelAll}
                agentsList={agentsList}
                salesPeopleListOrigin={salesPeopleListOrigin}
            />
        }

        {
            leadTreatmentPopUp ?
                <ClientAddTreatmentPopup
                    // messageTitle={newTreatmentType.toString()}
                    type={leadTreatmentType}
                    ClosePopup={setLeadtreatmentOff}
                    customerId={leadIdForTreatment ? leadIdForTreatment : ''}
                    showPopUpMessage={(content: string) => openMessagePopUp(content)}
                /> : " "
        }

        {
            documentLeadTaskUrl.length > 0 && (
                <TaskDocumentPopup
                    ClosePopup={() => onHideDocumentPopUp()}
                    documentUrl={documentLeadTaskUrl}
                />
            )
        }


        <div className='main-content rtl'>
            <Menu activePage='Leads' />
            <div className='center-content'>
                <Header PageName="לידים" />
                <div className='lleads'>
                    <section className="main-body">
                        <div className="content-header">
                            <div className="flex-centered flex-space-between  mobile-only">
                                <div className="content-main-title">לידים</div>
                                <div className="actions flex-centered flex-space-between">
                                    <div className="icon search"></div>
                                    <div className='icon refresh-counter' onClick={(e: any) => { clearFilterAll() }}></div>
                                    <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'firstStatus' && sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc'
                                        }`} onClick={() => sortLeadsBy('firstStatus')}></div>
                                    {checkPermissionsOfCreator() ? (
                                        <div className="icon add" onClick={(e: any) => newLead()}></div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                            <div className="flex-end desktop-only">
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', flexWrap: 'wrap' ,alignItems: 'center' }}>
                                        <div>
                                            <div className="filter-row-leads filter-row flex-centered flex-start flex-top">
                                                <div className="filter-input search">
                                                    <input type="text"
                                                        value={searchText ? searchText : ''}
                                                        onChange={(e: any) => handleSearchChange("searchText", e)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                doFilter();
                                                            }
                                                        }}
                                                        placeholder="חיפוש" />
                                                    <div className={`icon x-clear pointer ${!filter.searchText || filter.searchText == '' ? 'hide' : ''}`} onClick={() => clearFilterValue('searchText')}></div>
                                                    <div className="icon search"></div>
                                                </div>
                                            </div>
                                            <div className="filter-row-leads filter-row flex-centered flex-start flex-top" style={{ flexWrap: 'wrap' }}>
                                                <div>
                                                    <div className="filter-input createDateFrom">
                                                        <CompDatePicker placeholder={'מתאריך פתיחה'} value={filter.createDateFrom} onChange={(date: Date) => setStateData("createDateFrom", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.createDateFrom ? 'hide' : ''}`} onClick={() => clearDate('createDateFrom')}></div>
                                                    </div>
                                                    <div className="filter-input closeDateFrom">
                                                        <CompDatePicker placeholder={'מתאריך סגירה '} value={filter.closeDateFrom} onChange={(date: Date) => setStateData("closeDateFrom", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.closeDateFrom ? 'hide' : ''}`} onClick={() => clearDate('closeDateFrom')}></div>
                                                    </div>
                                                    <div className="filter-input deliveryDateFrom">
                                                        <CompDatePicker placeholder={'מתאריך הצעה/חידוש'} value={filter.deliveryDateFrom} onChange={(date: Date) => setStateData("deliveryDateFrom", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.deliveryDateFrom ? 'hide' : ''}`} onClick={() => clearDate('deliveryDateFrom')}></div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="filter-input createDateTo">
                                                        <CompDatePicker placeholder={'עד תאריך פתיחה'} value={filter.createDateTo} onChange={(date: Date) => setStateData("createDateTo", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.createDateTo ? 'hide' : ''}`} onClick={() => clearDate('createDateTo')}></div>
                                                    </div>
                                                    <div className="filter-input closeDateTo">
                                                        <CompDatePicker placeholder={'עד תאריך סגירה '} value={filter.closeDateTo} onChange={(date: Date) => setStateData("closeDateTo", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.closeDateTo ? 'hide' : ''}`} onClick={() => clearDate('closeDateTo')}></div>
                                                    </div>
                                                    <div className="filter-input deliveryDateTo">
                                                        <CompDatePicker placeholder={'עד תאריך הצעה/חידוש'} value={filter.deliveryDateTo} onChange={(date: Date) => setStateData("deliveryDateTo", date)} />
                                                        <div className={`icon x-clear pointer ${!filter.deliveryDateTo ? 'hide' : ''}`} onClick={() => clearDate('deliveryDateTo')}></div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <StationUserSelect data={{
                                                        branches: allBranches,
                                                        users: allUsers,
                                                        clearFilter: clearFilter,
                                                        saveState: dataLoaded
                                                    }} onChange={(data: any) => onStationUserChange(data)} />
                                                </div>



                                                <div>

                                                    <div className="filter-input" style={{ width: '180px' }}>
                                                        {searchStatuses ?
                                                            (
                                                                <>
                                                                    <Select
                                                                        mode='multiple'
                                                                        style={{ width: '100%' }}
                                                                        defaultValue={selectedStatus}
                                                                        value={selectedStatus}
                                                                        onChange={onStatusChange2}
                                                                        options={options}
                                                                        placeholder="סטטוס"
                                                                    />
                                                                </>
                                                            ) : ""
                                                        }
                                                    </div>
                                                    <div className="filter-input" style={{ width: '180px' }}>
                                                        <IDNameDescriptionItemSelect
                                                            OnChange={(name: string, value: any) => onPolicyTypeChange(name, value)}
                                                            Id={"policyType"}
                                                            Value={filter.policyType ? filter.policyType : '0'}
                                                            Options={LeadTopType}
                                                        />

                                                    </div>
                                                    <div className="filter-input" style={{ width: '180px' }}>
                                                        <IDNameDescriptionItemSelect
                                                            OnChange={(name: string, value: any) => onLeadTypeChange(name, value)}
                                                            Id={"leadType"}
                                                            Value={filter.leadType ? filter.leadType : '-1'}
                                                            Options={LeadTypes}
                                                            Disabled={filter.policyType !== '1'}
                                                        />
                                                    </div>

                                                </div>
                                                <div>
                                                    <div className="filter-input">
                                                        <input type='text'
                                                            list="manufacturer_list"
                                                            placeholder='יצרן'
                                                            onChange={(e: any) => onManufacturerChange(e)}
                                                            value={manufacturer ? manufacturer : ''}
                                                        />
                                                        <datalist id="manufacturer_list">
                                                            {manufacturesList.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                                        </datalist>
                                                        <div className={`icon x-clear pointer ${manufacturer == '' ? 'hide' : ''}`} onClick={() => clearFilterValue('manufacturerId')}></div>
                                                    </div>
                                                    <div className="filter-input">
                                                        <input type='text'
                                                            list="model_list"
                                                            placeholder='דגם'
                                                            onChange={(e: any) => onModelChange(e)}
                                                            value={vehicleModel ? vehicleModel : ""}
                                                        />
                                                        <datalist id="model_list">
                                                            {VehicleModelAutocomplete && VehicleModelAutocomplete.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                                        </datalist>
                                                        <div className={`icon x-clear pointer ${!filter.vehicleModel || filter.vehicleModel == '' ? 'hide' : ''}`} onClick={() => clearValue('vehicleModelId')}></div>
                                                    </div>
                                                    <div className="filter-input">
                                                        <input type='text'
                                                            placeholder='קוד דגם'
                                                            list="submodel_list"
                                                            onChange={(e: any) => onSubModelChange(e)}
                                                            value={vehicleSubModel ? vehicleSubModel : ""}
                                                        />
                                                        <datalist id="submodel_list">
                                                            {VehicleSubModelAutocomplete && VehicleSubModelAutocomplete.map((o: any, i) => <option key={i} value={o.label}>{o.label}</option>)}
                                                        </datalist>
                                                        <div className={`icon x-clear pointer ${!filter.vehicleSubModel || filter.vehicleSubModel == '' ? 'hide' : ''}`} onClick={() => clearValue('vehicleSubModelId')}></div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="filter-input">
                                                        <Select
                                                            style={{ width: '100%' }}
                                                            defaultValue={filter.carYear && filter.carYear !== '' ? filter.carYear : 'שנת יצור'}
                                                            value={selectedCarYear}
                                                            onChange={onCarYearChange}
                                                            options={
                                                                carYears.map((year: string) => {
                                                                    return {
                                                                        label: year,
                                                                        value: year
                                                                    }
                                                                })
                                                            }
                                                        />
                                                    </div>


                                                    <div className="filter-input">
                                                        <Select
                                                            style={{ width: '100%' }}
                                                            // defaultValue={filter.agentId && filter.agentId !== '' ? filter.agentId : 'סוכן'}
                                                            value={filter.agentId && filter.agentId !== '' ? filter.agentId : 'סוכן'}
                                                            onChange={onAgentChange}
                                                            options={
                                                                [
                                                                    {
                                                                        label: 'סוכן',
                                                                        value: ""
                                                                    },
                                                                    ...agentsList.map((agent: any) => {
                                                                        return {
                                                                            label: agent.name,
                                                                            value: agent.id
                                                                        }
                                                                    })
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                    <div className="filter-input">
                                                        <CustomSearchHandler
                                                            salesPeopleList={salesPeopleList}
                                                            onSalesManSelect={(value: any) => onSalesManSelect(value)}
                                                            selectedSaleManName={selectedSaleManName}
                                                            clearValue={() => onClearSalesManSelect()}
                                                        />

                                                    </div>
                                                </div>




                                                <div>
                                                    <div className="filter-button">
                                                        <button className="act-btn" onClick={(e: any) => doFilter()}>הצג דוח</button>
                                                    </div>
                                                    <div className="filter-button">
                                                        <button className="act-btn" onClick={(e: any) => { clearFilterAll() }}>נקה בחירה</button>
                                                    </div>
                                                    {hasPermissionToExport() &&
                                                        <div>
                                                            <button className='act-btn' onClick={(e: any) => showExportModel()}>יצוא לאקסל</button>
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                        </div>

                                    {checkPermissionsOfCreator() ?
                                        <div style={{ padding: '1rem'}}>
                                            <button type="button" onClick={(e: any) => newLead()} className="button blue has-icon flex-centered flex-justify-center">
                                                <div className="icon add" onClick={(e: any) => newLead()}></div>
                                                הוסף ליד
                                            </button>
                                        </div>
                                        : <></>}
                                    </div>
                                </div>
                                {data ? (
                                    <div className="table-header">
                                        <div className="icon-header pointer" onClick={() => sortLeadsBy('hasOffers')}>
                                            <div className="icon tag"></div>
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'lastStatusName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>

                                        <div className="status-cell-header pointer" onClick={() => sortLeadsBy('lastStatusName')}>
                                            סטטוס
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'lastStatusName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="date-cell-header pointer" onClick={() => sortLeadsBy('firstStatus')}>
                                            ת. יצירה
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'firstStatus' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="brunch-cell-header pointer" onClick={() => sortLeadsBy('BranchName')}>
                                            סניף
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'BranchName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="stage-cell-header pointer" onClick={() => sortLeadsBy('su.fullName')}>
                                            עמדה
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'su.fullName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="handler-cell-header pointer" onClick={() => sortLeadsBy('HanlerName')}>
                                            מטפל
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'HanlerName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="contact-cell-header pointer" onClick={() => sortLeadsBy('leadFullName')}>
                                            איש קשר
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'leadFullName' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="phone-cell-header pointer" onClick={() => sortLeadsBy('PhoneNumber1')}>
                                            טלפון
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'PhoneNumber1' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="docs-cell-header pointer" onClick={() => sortLeadsBy('hasCarLicenseFile')} title='מסמכים'>
                                            <div className="icon paperclip pointer"></div>
                                            {/* מסמכים */}
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'hasCarLicenseFile' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="prapaty-cell-header pointer" onClick={() => sortLeadsBy('LicenseNumber')}>
                                            נכס
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'LicenseNumber' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="leadType-cell-header pointer" onClick={() => sortLeadsBy('LeadType')}>
                                            סוג ליד
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'LeadType' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="year-cell-header pointer" onClick={() => sortLeadsBy('CarYear')}>
                                            שנה
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'CarYear' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="comment-cell-header pointer" onClick={() => sortLeadsBy('internalComment')}>
                                            הערות
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'internalComment' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="date-cell-header pointer" onClick={() => sortLeadsBy('DeliveryDate')}>
                                            <div className='title'>ת.מסירה/תחילת ביטוח</div>
                                            <div className={`icon sort ${sortLeedsBy && sortLeedsBy.name == 'DeliveryDate' ? sortLeedsBy.direction == 'ASC' ? 'asc' : 'desc' : 'hide'
                                                }`}></div>
                                        </div>
                                        <div className="button-cell-header"></div>
                                        <div className="actions-cell-header"></div>
                                    </div>
                                ) : ""}

                            </div>
                        </div>
                        {
                            leadsList && offerIdData != null && offer &&
                            <LeadOfferProduction
                                offer={offer}
                                onGoToSimulatorClick={(e: string) => onGoToSimulatorClick(e)}
                                onEdit={(e: any) => editLead(e)}
                            />
                        }



                        {leadsList ? (
                            <div className="content-body leads-list">

                                {leadsList.length > 0 ? leadsList.map((lead: SPLeadModel, index: number) => {
                                    const leadId = lead && lead.lead ? lead.lead.id : '';
                                    const isOpened = openedLeadId == leadId
                                    //console.log('isOpened', leadId, this.state, isOpened)
                                    return (
                                        <Lead
                                            lead={lead}
                                            oldLeadStatusesList={oldLeadStatusesList}
                                            getAuthorizedToDriveName={getAuthorizedToDriveName}
                                            onEdit={(e: any) => editLead(e)}
                                            onDelete={(e: any) => openDeletePropmpt(e)}
                                            isAdmin={isAdmin}
                                            opened={isOpened}
                                            openPopupMessage={(d: any) => openPopupMessage(d)}
                                            openDocumentPopup={(u: string) => openDocumentPopup(u)}
                                            updateLeadStatus={(v: string, s: string) => updateLeadStatus(v, s)}
                                            leadStatuses={leadStatuses}
                                            onGoToSimulatorClick={onGoToSimulatorClick}
                                            onCallStart={() => { }}
                                            key={index}
                                            checkPermissionsOfCreator={() => checkPermissionsOfCreator()}
                                            checkPermissionsOfEdit={() => checkPermissionsOfEdit()}
                                        ></Lead>
                                    )
                                }) : ""}

                            </div>
                        ) : ""}



                    </section>

                    {/* <Footer AllRowsCounter={this.state.data!=null && this.state.data.allRowsCounter!=null?this.state.data.allRowsCounter:0} rowsInPage={50} currentPage={1} /> */}

                    <footer className="footer emails-list-footer emails-list-view">
                        {pagerConf && pagerConf.currentPage > 0 &&
                            <Pagger pagerConf={pagerConf} changePage={(e: any) => onChangePage(e)} />
                        }
                    </footer>

                </div>
            </div>
            {
                loading && (
                    <PleaseWaitLayer />
                )
            }
            <LoginStatus onChange={(status: boolean) => onLoggedUserChange(status)} />
            {notLogged && <GoToLogin />}
            {
                !userLogged && <LoginPopup />
            }
        </div >



    </div >);
}

export default AllLeadsCopy;